import React, { lazy, Suspense } from 'react';
import TaskDetail from '../components/TaskDetail';
import s from './shell.module.css';

const SessionDetail = lazy(() => import('../components/SessionDetail'));
const EventDetail = lazy(() => import('../components/EventDetail'));

// The right-hand panel: whatever the URL names (?task= / ?session= / ?event=).
export default function DetailPanel({ kind, id, onClose }) {
  return (
    <aside className={s.panel} aria-label="Details">
      <Suspense fallback={<div style={{ padding: 20 }} className="faint">Loading…</div>}>
        {kind === 'task' ? <TaskDetail key={id} id={id} onClose={onClose} /> : null}
        {kind === 'session' ? <SessionDetail key={id} id={id} onClose={onClose} /> : null}
        {kind === 'event' ? <EventDetail key={id} id={id} onClose={onClose} /> : null}
      </Suspense>
    </aside>
  );
}
